import React from "react"
import styled from "styled-components"

import LoginHeader from "../Login/LoginHeader"

import { lightAntOverrides } from "./lightAntOverrides"

type PasswordAuthLayoutProps = {
  title: string
  children: React.ReactNode
}

// パスワードの再設定・メール確認の画面の外枠（ログイン画面と同じ白地）
const PasswordAuthLayout = (props: PasswordAuthLayoutProps): JSX.Element => {
  return (
    <Root>
      <LoginHeader />
      <Main>
        <Title>{props.title}</Title>
        {props.children}
      </Main>
    </Root>
  )
}

const Root = styled.div`
  ${lightAntOverrides}

  background: #fff;
  min-height: 100vh;
  padding: 40px;

  @media screen and (max-width: 1000px) {
    padding: 20px;
  }
`

const Main = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px 0;
  width: 360px;
  max-width: 100%;
  margin: 15vh auto 0;
`

const Title = styled.h1`
  color: #344054;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
`

export default PasswordAuthLayout
